import React from 'react'

import { RecordsHome } from './RecordsHome'

export const RecordsRoot = () => {
    return <RecordsHome />
}
